import { render, staticRenderFns } from "./AnchorLink.vue?vue&type=template&id=5dd5b9ed&scoped=true"
import script from "./AnchorLink.vue?vue&type=script&lang=js"
export * from "./AnchorLink.vue?vue&type=script&lang=js"
import style0 from "./AnchorLink.vue?vue&type=style&index=0&id=5dd5b9ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd5b9ed",
  null
  
)

export default component.exports